export const LAST_USED_PROVIDER_KEY = 'last_used_provider';

export const LOCALE_SELECTION = 'user_locale';

export const STATE_STORAGE_KEY_PREFIX = 'app_client_state_';
